import { render, staticRenderFns } from "./itemsSplitter.pug?vue&type=template&id=3d652df0&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./itemsSplitter.scss?vue&type=style&index=0&id=3d652df0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d652df0",
  null
  
)

export default component.exports